import { PreparedQuerySimple } from '@aipb/gulliver/catalog/env';
import { PreparedQueryModel } from '@aipb/gulliver/catalog/model';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'cat-dashboard-simple-card-item',
  templateUrl: './dashboard-simple-card-item.component.html',
  styleUrls: ['./dashboard-simple-card-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatCardModule, MatDividerModule, MatButtonModule, TranslocoModule]
})
export class DashboardSimpleCardItemComponent implements OnChanges {
  @Input() item: PreparedQueryModel;
  @Input() settings: PreparedQuerySimple;
  @Output() search = new EventEmitter<PreparedQueryModel>();

  styleBackground = '';

  ngOnChanges() {
    this.styleBackground = `linear-gradient(${this.settings.fromColor}, ${this.settings.toColor})`;
  }
}
